export const iconColor = "#FFF";
export const iconSize = 17;